import { NgIf } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subject, takeUntil } from 'rxjs';
import { StateNotifyService } from '../../../../common/state/service/state-notify.service';
import { Router } from '@angular/router';
import { BoolDto } from '../../../../common/dto/bool-dto';
import { RecommendationPropertiesService } from '../../../recommendation/service/recommendation-properties.service';
import { RecommendationType } from '../../../recommendation/dto/recommendation-type';
import { StepRecom } from '../../interface/step-recom';
import { StepRecomService } from '../../service/step-recom.service';
import { TestStep } from '../../../test-step/dto/test-step';

@Component({
  selector: 'dpi-test-step-recom',
  imports: [MatCardModule, MatTableModule, MatIconModule, MatButtonModule, MatToolbarModule, MatButtonToggleModule,
    MatTooltipModule, NgIf],
  templateUrl: './test-step-recom.component.html',
  styleUrl: './test-step-recom.component.scss'
})
export class TestStepRecomComponent implements OnInit, OnDestroy  {
  displayedColumns: string[] = ['sn', 'description', 'type', 'closed'];
  dataSource: StepRecom[] = [];
  destroyed$ = new Subject<void>(); // notifier of component destroyed
  @Output('listSizeChanged') listSize = new EventEmitter<number>();
  isReadonly: boolean;

  recommendationType: RecommendationType[];
  closedStates: BoolDto[];

  constructor(private notifyService: StateNotifyService
    , private stepRecomService: StepRecomService
    , private recommendationPropertiesService: RecommendationPropertiesService
    , private router: Router) {
    this.isReadonly = true;
    this.recommendationType = this.recommendationPropertiesService.getAllRecommendationTypes();
    this.closedStates = this.recommendationPropertiesService.getAllRecommendationClosedStates();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.notifyService.testStepSelection$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(model => {
        this.reload(model);
      });

    this.notifyService.readonlyMode$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(res => {
        this.onEditModeChange(res);
      });
  }

  reload(selectedTestStep: TestStep) {
    this.stepRecomService.getAllStepRecomOfTestStep(selectedTestStep.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res: any) => {
          this.dataSource = res;
          this.notifyService.updateListAllStepRecom(this.dataSource);
          this.listSize.emit(this.dataSource.length);
          for (var rec of this.dataSource) {
            let rec_type = this.recommendationPropertiesService.getRecommendationType(this.recommendationType, rec.type);
            rec.type_text = rec_type.name;
            let rec_state = this.recommendationPropertiesService.getRecommendationClosedState(this.closedStates, rec.closed);
            rec.closed_text = rec_state.expression;
          }
        },
        error: (error: any) => {
          console.error('Error: ', error);
          this.dataSource = [];
        }
      })
  }

  onEditModeChange(isReadonly: boolean) {
    this.isReadonly = isReadonly;
  }

  selectStepRecom(selected: StepRecom) {
    this.notifyService.updateStepRecomSelection(selected);
    this.router.navigate(['step-recom-hub']);
  }

  createStepRecom() {
    let testStepModel = this.notifyService.getSelectedTestStep();
    this.stepRecomService.createStepRecom(testStepModel.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: model => {
          this.dataSource.push(model);
          this.selectStepRecom(model);
        },
        error: err => { console.log(err); }
      });
  }

}
